import styled from 'styled-components';
import useInsightsSetting from '../../../../../Insights/useInsights/useInsightsSetting';
import Icon from 'components/base/Icon';
import { mapInsightToChipTitle } from '../../../../../Insights/insights.view';
import { capitalize } from 'lodash';

const StyledInsightsTooltip = styled.div`
  padding: 0.5rem;
  & > header {
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-bottom: 1rem;
  }
`;

const StyledInsightItem = styled.li``;

const InsightsTooltip = ({ insightsKeys, pmProvider }) => {
  const { getInsightByKey } = useInsightsSetting();
  const insights = insightsKeys.map(getInsightByKey);

  return (
    <StyledInsightsTooltip>
      <header>
        <Icon
          name='Alert'
          color='neonCarrot'
          size='small'
          style={{ marginRight: '1rem' }}
        />
        Issue Insights:
      </header>
      <ul>
        {insights.map(insight => (
          <StyledInsightItem key={insight.key}>
            {capitalize(mapInsightToChipTitle({ insight, pmProvider }))}
          </StyledInsightItem>
        ))}
      </ul>
    </StyledInsightsTooltip>
  );
};

export default InsightsTooltip;
